var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsDaily(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 109,
    viewBox: "0 0 102 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_183171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7947 37.8608L93.1357 36.8919L91.628 36.0104L73.9671 25.694L68.2781 22.3706C67.4486 21.9566 66.3361 22.0552 65.1142 22.7649L59.4281 26.0657C57.6597 27.0909 56.2557 28.6427 55.4038 30.5072L47.372 48.1181C46.4837 50.0698 45.0516 51.7512 43.5215 52.6384L36.0054 57.001C36.0838 57.4798 36.1371 61.5579 36.1371 61.5579L49.2104 55.9646L52.3435 55.3703C52.3435 55.3703 57.6261 47.4816 61.7205 41.3672L80.4379 52.3004L93.3122 44.1639L88.8984 41.5869L94.7947 37.8608Z",
    fill: "#FFD554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1358 36.8919L91.4767 35.9231L89.969 35.0415L72.3081 24.7251L66.6192 21.4018C65.7897 20.9877 64.6771 21.0863 63.4553 21.7961L57.7691 25.0969C56.0008 26.122 54.5968 27.6739 53.7448 29.5383L45.7131 47.1492C44.8247 49.101 43.3927 50.7824 41.8626 51.6695L34.3464 56.0321C34.4249 56.5109 34.4782 60.589 34.4782 60.589L47.5515 54.9957L50.6846 54.4014C50.6846 54.4014 55.9672 46.5127 60.0615 40.3983L78.7789 51.3316L91.6533 43.195L87.2395 40.618L93.1358 36.8919Z",
    fill: "#FFDE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.968 43.1725L77.8064 29.6454L54.5967 43.2007L77.7588 56.7278L100.968 43.1725Z",
    fill: "#FFDE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0037 29.4539C60.9164 30.3833 60.0364 31.5436 59.4367 32.8617L51.8169 52.5201C51.7608 52.6412 51.7188 52.7708 51.688 52.906C53.4143 50.329 57.0574 44.8877 60.0644 40.3955L65.7534 43.7189L78.7819 51.3288L88.7165 45.051L62.0065 29.451L62.0037 29.4539Z",
    fill: "#FFC533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7734 44.0793L37.5665 57.6346L33.7244 55.39L35.2321 58.9978L54.552 70.2802L80.0934 55.3646L60.7734 44.0793Z",
    fill: "#1C1F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4703 42.3951L36.2634 55.9476L33.7244 54.4662L33.9289 57.3136L54.552 69.3565L80.0934 54.438L59.4703 42.3951Z",
    fill: "#3F424A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7705 55.8124C66.622 55.8997 66.4595 55.9702 66.2857 56.0265C66.1512 56.0715 66.0111 56.1053 65.8682 56.1307C65.7757 56.1476 65.6804 56.1617 65.5851 56.1701C65.5039 56.1786 65.4226 56.1842 65.3413 56.187C65.2656 56.187 65.19 56.1898 65.1143 56.187C65.0415 56.187 64.9686 56.1814 64.8957 56.1758C64.8229 56.1701 64.7528 56.1617 64.6799 56.1504C64.6071 56.1391 64.5342 56.1279 64.4613 56.111C64.3829 56.0941 64.3072 56.0772 64.2315 56.0547C64.1391 56.0293 64.0494 55.9983 63.9625 55.9645C63.8504 55.9195 63.7439 55.8688 63.643 55.8096L49.6589 47.6956C49.2217 47.4421 49.006 47.1098 49.006 46.7803L48.9919 51.7202C48.9919 52.0526 49.2077 52.3821 49.6449 52.6356L63.629 60.7496C63.7299 60.8087 63.8364 60.8594 63.9485 60.9045C64.0354 60.9383 64.1251 60.9693 64.2175 60.9946C64.2932 61.0171 64.3689 61.034 64.4473 61.0509C64.5202 61.065 64.5931 61.0791 64.6659 61.0904C64.736 61.1016 64.8088 61.1073 64.8789 61.1157C64.9518 61.1213 65.0246 61.1242 65.0975 61.127C65.1732 61.127 65.2488 61.127 65.3245 61.127C65.4058 61.1242 65.487 61.1185 65.5683 61.1101C65.6636 61.1016 65.7561 61.0875 65.8514 61.0706C65.9943 61.0453 66.1344 61.0087 66.2689 60.9664C66.4427 60.9101 66.6052 60.8397 66.7537 60.7524L81.8336 51.9455L81.8476 47.0056L66.7677 55.8124H66.7705Z",
    fill: "url(#paint0_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.545 46.2424L66.6193 54.9591C65.843 55.4125 64.5875 55.4125 63.8085 54.9591L49.8243 46.8451C49.3507 46.5691 49.163 46.1917 49.2639 45.834C49.191 46.003 49.0284 46.6367 49.0284 46.6367C48.9528 47.0112 49.163 47.4027 49.659 47.6928V47.6787L49.6674 47.6984L63.6515 55.8125C63.716 55.8491 63.7804 55.8829 63.8477 55.9138C63.8533 55.9167 63.8589 55.9195 63.8673 55.9223C63.8869 55.9307 63.9065 55.9392 63.9262 55.9476C63.9598 55.9617 63.9962 55.9758 64.0327 55.9899C64.0411 55.9927 64.0523 55.9983 64.0607 56.0012C64.0831 56.0096 64.1083 56.0152 64.1335 56.0237C64.1616 56.0321 64.1868 56.0406 64.2148 56.049C64.2232 56.049 64.2316 56.0547 64.24 56.0575C64.2709 56.0659 64.3045 56.0744 64.3381 56.0828C64.3577 56.0885 64.3774 56.0941 64.397 56.0969C64.4026 56.0969 64.4054 56.0969 64.411 56.0997C64.467 56.111 64.5231 56.1223 64.5791 56.1335C64.5931 56.1335 64.6015 56.1363 64.61 56.1392C64.6548 56.1476 64.6996 56.1532 64.7473 56.1589C64.7557 56.1589 64.7641 56.1589 64.7725 56.1589C64.7949 56.1589 64.8145 56.1645 64.837 56.1645C64.8622 56.1645 64.8902 56.1701 64.9154 56.173C64.9322 56.173 64.9491 56.173 64.9659 56.173C64.9911 56.173 65.0135 56.1758 65.0387 56.1758C65.0555 56.1758 65.0724 56.1758 65.092 56.1786C65.1172 56.1786 65.1396 56.1786 65.1648 56.1786C65.1901 56.1786 65.2153 56.1786 65.2405 56.1786C65.2517 56.1786 65.2629 56.1786 65.2741 56.1786C65.3022 56.1786 65.333 56.1786 65.361 56.1758C65.389 56.1758 65.4171 56.1758 65.4451 56.173C65.4535 56.173 65.4591 56.173 65.4675 56.173C65.4955 56.173 65.5207 56.1673 65.5488 56.1645C65.5852 56.1617 65.6216 56.1589 65.6581 56.1532C65.6665 56.1532 65.6721 56.1532 65.6805 56.1532C65.6973 56.1532 65.7141 56.1476 65.7337 56.1448C65.787 56.1363 65.843 56.1279 65.8963 56.1194C65.9075 56.1194 65.9215 56.1166 65.9355 56.1138C65.9439 56.1138 65.9523 56.1082 65.9607 56.1082C66.0784 56.0828 66.1961 56.0519 66.3054 56.0152C66.3138 56.0152 66.3222 56.0124 66.3278 56.0096C66.3419 56.004 66.3559 55.9983 66.3699 55.9927C66.4119 55.9786 66.454 55.9617 66.496 55.942C66.5212 55.9307 66.5464 55.9223 66.5717 55.911C66.6137 55.8913 66.6557 55.8688 66.6978 55.8491C66.7146 55.8406 66.7314 55.835 66.7454 55.8265C66.7566 55.8209 66.765 55.8153 66.7762 55.8096L81.8561 47.0028L81.5478 46.2395L81.545 46.2424Z",
    fill: "url(#paint1_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.545 46.2424L66.6192 54.9591C65.843 55.4125 64.5875 55.4125 63.8084 54.9591L49.8243 46.8451C49.0452 46.3916 49.0396 45.6594 49.8159 45.2087L64.7416 36.492L81.5478 46.2424H81.545Z",
    fill: "#66686A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4632 33.011L67.7065 29.0905C67.628 29.0455 67.5552 29.0173 67.4851 28.9976C67.0535 28.8286 66.7229 29.068 66.7201 29.589V29.62L66.6948 38.8043C66.6948 39.5225 66.3165 40.1815 65.7 40.542L59.2656 44.2991C58.7668 44.5891 58.7696 45.0623 59.274 45.3552L66.0307 49.2756C66.1091 49.3207 66.1988 49.3573 66.2941 49.3911C66.7957 49.5882 67.4795 49.5601 67.9195 49.301L73.8298 46.4029C74.7686 45.8537 75.3487 44.8454 75.3515 43.7527L75.3712 34.6191V34.5881C75.3712 34.008 74.9676 33.301 74.4632 33.0081V33.011Z",
    fill: "#57595A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5351 50.574C65.9494 50.9148 64.9994 50.9148 64.4081 50.574L57.6515 46.6536C57.5337 46.586 57.4385 46.5071 57.3684 46.4254L57.5646 46.6508C57.6262 46.7212 57.7047 46.7859 57.8056 46.8451L64.5622 50.7655C65.0667 51.0584 65.8794 51.0584 66.3782 50.7655L73.8046 46.4283L74.1157 46.1438L66.5323 50.5712L66.5351 50.574Z",
    fill: "url(#paint2_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2362 35.5542V35.3852C74.2362 35.3852 74.2362 35.3598 74.2362 35.3457C74.2362 35.3232 74.2362 35.3007 74.2334 35.2782C74.2334 35.2556 74.2306 35.2331 74.2277 35.2106C74.2277 35.188 74.2221 35.1655 74.2193 35.143C74.2193 35.1373 74.2193 35.1317 74.2193 35.1261C74.2165 35.1035 74.2137 35.0895 74.2109 35.0754C74.2081 35.0528 74.2025 35.0331 74.1969 35.0106C74.1913 34.9909 74.1885 34.9684 74.1829 34.9486C74.1773 34.9289 74.1745 34.912 74.1689 34.8923C74.1661 34.881 74.1633 34.8698 74.1577 34.8585C74.1577 34.8501 74.1549 34.8444 74.1521 34.8388C74.1465 34.8219 74.1437 34.8078 74.1381 34.7909C74.1325 34.7768 74.1269 34.7599 74.1213 34.7459C74.1157 34.7318 74.1129 34.7205 74.1072 34.7064C74.1016 34.6923 74.096 34.6811 74.0932 34.667C74.0876 34.6557 74.082 34.6417 74.0792 34.6304C74.0736 34.6191 74.0708 34.6079 74.0652 34.5966C74.0568 34.5797 74.054 34.5712 74.0512 34.5628C74.0456 34.5515 74.04 34.5403 74.0344 34.5262C74.0288 34.5149 74.0232 34.5008 74.0176 34.4896C74.012 34.4783 74.0064 34.4642 73.9979 34.453C73.9895 34.4389 73.9811 34.422 73.9755 34.4079C73.9671 34.391 73.9559 34.3713 73.9475 34.3544C73.9279 34.3206 73.9139 34.3009 73.8999 34.2783C73.8718 34.2305 73.8438 34.1854 73.813 34.1403C73.8018 34.1263 73.7934 34.1094 73.7822 34.0953C73.7682 34.0756 73.7597 34.0643 73.7513 34.053C73.7429 34.0418 73.7345 34.0305 73.7233 34.0192C73.7149 34.008 73.7065 33.9967 73.6981 33.9882C73.6897 33.977 73.6813 33.9685 73.6729 33.9573C73.6645 33.946 73.6561 33.9376 73.6476 33.9263C73.6392 33.915 73.6308 33.9066 73.6196 33.8953C73.6112 33.8869 73.6056 33.8784 73.5972 33.8728C73.5804 33.8531 73.5692 33.8446 73.558 33.8333C73.5468 33.8221 73.5355 33.8108 73.5243 33.8024C73.5103 33.7911 73.4991 33.777 73.4851 33.7658C73.4711 33.7545 73.4571 33.7404 73.4431 33.7291C73.4263 33.7151 73.4122 33.701 73.3954 33.6897C73.3758 33.6728 73.3618 33.6615 73.345 33.6503C73.3254 33.6362 73.3086 33.6221 73.2889 33.6108C73.2693 33.5968 73.2525 33.5855 73.2329 33.5742C73.2133 33.563 73.1965 33.5517 73.1768 33.5404L66.4202 29.62C66.4006 29.6088 66.381 29.5975 66.3613 29.589C66.3417 29.5806 66.3249 29.5693 66.3053 29.5609C66.2857 29.5524 66.2689 29.544 66.2492 29.5383C66.2296 29.5299 66.2128 29.5243 66.1932 29.5186C66.1736 29.513 66.1568 29.5074 66.1371 29.5017C66.1175 29.4961 66.1007 29.4933 66.0811 29.4877C66.0615 29.4848 66.0419 29.482 66.0222 29.4792C66.0026 29.4792 65.9802 29.4764 65.9606 29.4736C65.9382 29.4736 65.9157 29.4736 65.8961 29.4736C65.8709 29.4736 65.8457 29.4792 65.8233 29.4848C65.7924 29.4905 65.7644 29.4989 65.7364 29.5102C65.5823 29.5693 65.4674 29.6961 65.4029 29.8848L65.3076 30.1692C65.3609 30.0087 65.4618 29.8988 65.5907 29.8482C65.6131 29.8397 65.6383 29.8313 65.6635 29.8256C65.6831 29.8228 65.7056 29.82 65.7252 29.8172C65.7448 29.8172 65.7616 29.8172 65.7812 29.8172C65.798 29.8172 65.8149 29.8172 65.8345 29.82C65.8513 29.82 65.8681 29.8256 65.8849 29.8284C65.9017 29.8313 65.9157 29.8341 65.9326 29.8397C65.9494 29.8425 65.9634 29.8482 65.9802 29.8538C65.997 29.8594 66.011 29.865 66.0278 29.8707C66.0447 29.8763 66.0587 29.8848 66.0755 29.8904C66.0923 29.8988 66.1063 29.9045 66.1231 29.9129C66.1399 29.9214 66.1568 29.9298 66.1708 29.9411L72.9302 33.8615C72.9919 33.8981 73.0535 33.9404 73.1124 33.9882C73.1712 34.0361 73.2301 34.0896 73.2833 34.1488C73.3394 34.2079 73.3898 34.2699 73.4375 34.3347C73.4767 34.3882 73.5103 34.4417 73.5412 34.4952C73.5524 34.5149 73.5664 34.5318 73.5748 34.5515C73.614 34.6191 73.6505 34.6895 73.6813 34.7628C73.7149 34.8388 73.7429 34.9148 73.7653 34.9881C73.7878 35.0669 73.8046 35.1402 73.8186 35.2134C73.8298 35.2894 73.8354 35.357 73.8354 35.4218C73.8354 35.4274 73.8354 35.4331 73.8354 35.4387L73.8102 42.9162C73.8102 43.6316 73.4319 44.2934 72.8153 44.6539L72.3866 44.9046C72.451 44.9694 72.5155 45.0341 72.5799 45.0989C72.6135 45.1327 72.6416 45.1693 72.6668 45.2059L73.1264 44.9384C73.7429 44.5779 74.2334 43.7639 74.2334 43.0458L74.2558 35.5682L74.2334 35.557L74.2362 35.5542Z",
    fill: "url(#paint3_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8325 36.3597L73.8101 42.9162C73.8101 43.6316 73.4318 44.2934 72.8152 44.6539L72.3865 44.9046C72.4509 44.9694 72.5154 45.0342 72.5798 45.0989C72.6135 45.1327 72.6415 45.1693 72.6667 45.206L73.1263 44.9384C73.7429 44.5779 74.2333 43.764 74.2333 43.0458L74.2529 36.2076C74.1128 36.2611 73.9727 36.3118 73.8297 36.3597H73.8325Z",
    fill: "url(#paint4_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5378 48.7828L73.1263 44.9356L72.8153 44.6511L66.3809 48.4082C66.3192 48.4448 66.252 48.4758 66.1791 48.5039C66.1119 48.5293 66.039 48.5518 65.9661 48.5687C65.9549 48.5687 65.9437 48.5744 65.9325 48.5772C65.8625 48.5941 65.7924 48.6053 65.7195 48.6138C65.6355 48.6222 65.5542 48.6279 65.4729 48.6279C65.3888 48.6279 65.3076 48.6222 65.2263 48.6138C65.145 48.6053 65.0666 48.5913 64.9881 48.5715C64.9096 48.5518 64.8368 48.5293 64.7667 48.5039C64.6882 48.473 64.621 48.442 64.5593 48.4054L57.8027 44.4849C57.783 44.4737 57.7634 44.4596 57.7438 44.4483C57.7186 44.4314 57.6962 44.4145 57.6738 44.3976C57.6485 44.3779 57.6261 44.3554 57.6037 44.3357C57.5785 44.3103 57.5532 44.2822 57.5336 44.2568C57.5056 44.2202 57.4832 44.1808 57.4664 44.1413C57.3879 43.9667 57.4215 43.778 57.5645 43.6147L57.3683 43.84C57.2001 44.0315 57.1637 44.2512 57.2534 44.4568C57.273 44.5019 57.301 44.5469 57.3319 44.5892C57.3571 44.6201 57.3823 44.6511 57.4131 44.6821C57.4383 44.7074 57.4664 44.73 57.4972 44.7553C57.5224 44.775 57.5504 44.7948 57.5813 44.8145C57.6037 44.8285 57.6261 44.8426 57.6513 44.8567L64.408 48.7771C64.408 48.7771 64.4164 48.7828 64.422 48.7856C64.45 48.7997 64.478 48.8166 64.5061 48.8306C64.5341 48.8447 64.5621 48.856 64.5901 48.8673C64.607 48.8729 64.6238 48.8813 64.6378 48.887C64.6574 48.8954 64.663 48.8982 64.6714 48.9011C64.6994 48.9095 64.7247 48.9208 64.7527 48.9292C64.7807 48.9377 64.8059 48.9461 64.834 48.9517C64.8564 48.9574 64.8788 48.963 64.9012 48.9686C64.9376 48.9771 64.9629 48.9827 64.9881 48.9884C65.0105 48.994 65.0329 48.9968 65.0582 48.9996C65.0806 49.0024 65.103 49.0053 65.1254 49.0109C65.145 49.0109 65.1618 49.0165 65.1815 49.0165C65.2039 49.0165 65.2207 49.0193 65.2375 49.0222C65.2515 49.0222 65.2683 49.0222 65.2852 49.025C65.2992 49.025 65.316 49.025 65.33 49.0278C65.344 49.0278 65.358 49.0278 65.372 49.0278C65.386 49.0278 65.3972 49.0278 65.4113 49.0278C65.4253 49.0278 65.4365 49.0278 65.4505 49.0278C65.4589 49.0278 65.4645 49.0278 65.4729 49.0278C65.4785 49.0278 65.4841 49.0278 65.4869 49.0278C65.4981 49.0278 65.5093 49.0278 65.5206 49.0278C65.5318 49.0278 65.543 49.0278 65.5542 49.0278C65.5654 49.0278 65.5766 49.0278 65.5878 49.0278C65.599 49.0278 65.6102 49.0278 65.6242 49.0278C65.6355 49.0278 65.6467 49.0278 65.6607 49.0278C65.6719 49.0278 65.6831 49.0278 65.6971 49.025C65.7111 49.025 65.7251 49.025 65.7391 49.0222C65.7447 49.0222 65.7504 49.0222 65.7588 49.0222C65.77 49.0222 65.7756 49.0222 65.784 49.0222C65.8008 49.0222 65.8176 49.0165 65.8344 49.0165C65.8596 49.0137 65.8849 49.0081 65.9073 49.0053C65.9437 48.9996 65.9774 48.9912 66.011 48.9827C66.025 48.9799 66.0362 48.9771 66.0502 48.9743C66.0586 48.9743 66.067 48.9715 66.0726 48.9686C66.1007 48.9602 66.1287 48.9546 66.1539 48.9461C66.1707 48.9405 66.1875 48.9348 66.2043 48.9292C66.2212 48.9236 66.238 48.918 66.252 48.9123C66.266 48.9067 66.28 48.9011 66.294 48.8954C66.308 48.8898 66.3221 48.8842 66.3361 48.8785C66.3501 48.8729 66.3669 48.8644 66.3809 48.8588C66.3949 48.8532 66.4117 48.8447 66.4257 48.8391C66.4426 48.8306 66.4622 48.8222 66.479 48.8137C66.4958 48.8053 66.5126 48.7968 66.5294 48.7856L66.5378 48.7828Z",
    fill: "url(#paint5_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2982 34.7177C75.2982 34.7008 75.2982 34.6839 75.2982 34.667C75.2982 34.6501 75.2982 34.6332 75.2954 34.6163C75.2954 34.5994 75.2926 34.5825 75.2898 34.5628C75.2898 34.5459 75.2842 34.5262 75.2814 34.5093C75.2786 34.4895 75.2758 34.4726 75.273 34.4557C75.2702 34.436 75.2645 34.4191 75.2617 34.3994C75.2589 34.3797 75.2533 34.3628 75.2477 34.3431C75.2421 34.3234 75.2393 34.3065 75.2337 34.2868C75.2309 34.2727 75.2253 34.2558 75.2197 34.2417C75.2113 34.2107 75.2057 34.1938 75.1973 34.1741C75.1917 34.1572 75.1861 34.1375 75.1777 34.1206C75.1721 34.1037 75.1637 34.0868 75.1581 34.0671C75.1525 34.0502 75.144 34.0333 75.1384 34.0164C75.1328 34.0023 75.1272 33.991 75.1216 33.977C75.1104 33.9488 75.102 33.9319 75.0936 33.915C75.0852 33.8953 75.0768 33.8784 75.0656 33.8587C75.0544 33.8361 75.0432 33.8164 75.0319 33.7939C75.0207 33.7714 75.0067 33.7488 74.9927 33.7235C74.9843 33.7066 74.9815 33.7038 74.9787 33.6981C74.9535 33.6559 74.9283 33.6136 74.9002 33.5714C74.8778 33.5376 74.8554 33.5066 74.833 33.4756C74.8162 33.4559 74.8021 33.4334 74.7853 33.4137C74.7713 33.3968 74.7573 33.3799 74.7433 33.363C74.7293 33.3461 74.7153 33.3292 74.7013 33.3151C74.6872 33.2982 74.6732 33.2841 74.6592 33.27C74.6368 33.2447 74.6256 33.2362 74.6144 33.225C74.6004 33.2109 74.5836 33.194 74.5695 33.1799C74.5527 33.1658 74.5387 33.1518 74.5219 33.1349C74.5051 33.1208 74.4911 33.1067 74.4743 33.0926C74.4659 33.087 74.4575 33.0785 74.449 33.0729C74.4378 33.0644 74.4322 33.0588 74.4266 33.0532C74.4098 33.0419 74.3958 33.0278 74.379 33.0166C74.365 33.0053 74.3482 32.994 74.3313 32.9828C74.3173 32.9715 74.3005 32.9631 74.2865 32.9518C74.2725 32.9433 74.2557 32.9321 74.2417 32.9236C74.2305 32.918 67.4738 28.9976 67.4738 28.9976C67.4626 28.9919 67.4514 28.9835 67.4402 28.9779C67.4262 28.9694 67.4121 28.961 67.3953 28.9553C67.3813 28.9469 67.3673 28.9413 67.3533 28.9356C67.3393 28.93 67.3253 28.9244 67.3113 28.9187C67.2972 28.9131 67.2832 28.9075 67.2692 28.9018C67.2552 28.8962 67.2412 28.8934 67.2272 28.8877C67.2132 28.8821 67.1964 28.8793 67.1823 28.8765C67.1683 28.8737 67.1543 28.8708 67.1375 28.868C67.1207 28.8652 67.1067 28.8624 67.0899 28.8596C67.073 28.8596 67.059 28.8568 67.0422 28.8539C67.0254 28.8539 67.0086 28.8539 66.9918 28.8539C66.9722 28.8539 66.9553 28.8539 66.9357 28.8539C66.9161 28.8539 66.8937 28.8596 66.8741 28.8624C66.8489 28.868 66.8236 28.8737 66.7984 28.8821C66.7676 28.8934 66.7396 28.9075 66.7115 28.9215L65.6494 29.5411C65.6774 29.5242 65.7055 29.513 65.7363 29.5017C65.7615 29.4933 65.7839 29.4876 65.812 29.482C65.8316 29.4792 65.8512 29.4764 65.8736 29.4736C65.8904 29.4736 65.91 29.4736 65.9297 29.4736C65.9465 29.4736 65.9633 29.4736 65.9801 29.4736C65.9969 29.4736 66.0109 29.4735 66.0277 29.4792C66.0418 29.4792 66.0586 29.4848 66.0754 29.4876C66.0894 29.4904 66.1034 29.4933 66.1202 29.4961C66.1342 29.4989 66.1482 29.5045 66.1651 29.5073C66.1791 29.513 66.1931 29.5158 66.2071 29.5214C66.2211 29.5271 66.2351 29.5327 66.2491 29.5383C66.2631 29.544 66.2772 29.5496 66.2912 29.5552C66.3052 29.5609 66.3192 29.5693 66.3332 29.5749C66.3472 29.5834 66.3612 29.589 66.378 29.5975C66.3893 29.6031 66.4005 29.6087 66.4117 29.6172L73.1683 33.5376C73.2412 33.5798 73.3113 33.6305 73.3813 33.6869C73.4542 33.746 73.5186 33.808 73.5831 33.8756C73.6504 33.946 73.7092 34.0192 73.7653 34.0952C73.8213 34.1713 73.8717 34.2502 73.9194 34.3346C73.9726 34.4276 74.0147 34.5093 74.0511 34.5966C74.0903 34.6867 74.1212 34.774 74.1492 34.8613C74.1772 34.9542 74.1968 35.0416 74.2108 35.1289C74.2248 35.219 74.2333 35.3063 74.2333 35.3908L74.208 43.0486L75.2702 42.429L75.2954 34.7712C75.2954 34.7543 75.2954 34.7402 75.2954 34.7233L75.2982 34.7177Z",
    fill: "url(#paint6_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5378 48.7827C66.4734 48.8222 66.4005 48.8531 66.3276 48.8813C66.308 48.8898 66.2884 48.8954 66.2688 48.9038C66.224 48.9207 66.1763 48.9348 66.1287 48.9461C66.0782 48.9602 66.0306 48.9742 65.9773 48.9827C65.9157 48.994 65.8568 49.0052 65.7924 49.0137C65.7784 49.0137 65.7644 49.0193 65.7475 49.0193C65.6635 49.0278 65.5794 49.0334 65.4953 49.0334C65.4813 49.0334 65.4673 49.0334 65.4561 49.0334C65.372 49.0334 65.2879 49.0278 65.2067 49.0193C65.1955 49.0193 65.1814 49.0193 65.1702 49.0165C65.089 49.0052 65.0077 48.994 64.9292 48.9742C64.9152 48.9714 64.9012 48.9686 64.8872 48.963C64.8143 48.9461 64.7443 48.9236 64.677 48.8982C64.6658 48.8926 64.6518 48.8898 64.6406 48.8869C64.5593 48.856 64.4836 48.8193 64.4108 48.7771L57.6541 44.8567C57.3571 44.6849 57.2085 44.4596 57.2085 44.2314V46.0227C57.2057 46.248 57.3515 46.4733 57.6485 46.6479L64.4052 50.5683C64.4724 50.6078 64.5453 50.6416 64.6238 50.6725C64.649 50.681 64.6602 50.6838 64.6714 50.6894C64.7162 50.7063 64.7583 50.7204 64.8059 50.7345C64.8311 50.7401 64.8564 50.7458 64.8816 50.7542C64.8956 50.757 64.9096 50.7627 64.9236 50.7655C64.9376 50.7683 64.9488 50.7711 64.9629 50.7739C65.0133 50.7852 65.0609 50.7936 65.1114 50.7993C65.1282 50.7993 65.1478 50.8021 65.1646 50.8049C65.1758 50.8049 65.1899 50.8077 65.2011 50.8077C65.2207 50.8077 65.2375 50.8134 65.2571 50.8134C65.3076 50.8162 65.3552 50.819 65.4056 50.8218C65.4197 50.8218 65.4365 50.8218 65.4505 50.8218C65.4645 50.8218 65.4785 50.8218 65.4897 50.8218C65.5121 50.8218 65.5345 50.8218 65.557 50.8218C65.613 50.8218 65.6691 50.8162 65.7223 50.8105C65.7279 50.8105 65.7335 50.8105 65.7419 50.8105C65.7559 50.8105 65.77 50.8049 65.7868 50.8049C65.8288 50.7993 65.8736 50.7936 65.9157 50.788C65.9353 50.7852 65.9521 50.7796 65.9689 50.7739C66.0194 50.7627 66.0698 50.7514 66.1203 50.7373C66.1455 50.7289 66.1735 50.726 66.2015 50.7176C66.2211 50.712 66.2408 50.7007 66.2632 50.6951C66.2828 50.6866 66.3024 50.681 66.322 50.6725C66.3949 50.6416 66.4678 50.6106 66.5322 50.574L73.1207 46.7268V44.9355L66.535 48.7827H66.5378Z",
    fill: "url(#paint7_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8354 35.4387C73.8354 34.8585 73.4318 34.1516 72.9274 33.8587L66.1708 29.9382C65.6663 29.6453 65.2572 29.8791 65.2572 30.4593V30.4903L65.2319 37.9368C65.2319 38.655 64.8536 39.314 64.2371 39.6745L57.8027 43.4316C57.3039 43.7217 57.3067 44.1948 57.8111 44.4877L64.5678 48.4081C65.0722 48.701 65.8849 48.701 66.3837 48.4081L72.8181 44.6511C73.4346 44.2906 73.813 43.6315 73.8158 42.9134L73.8354 35.4668V35.4358V35.4387Z",
    fill: "url(#paint8_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5215 52.6384L49.2104 55.9617L41.6943 60.3215L36.0054 56.9981L43.5215 52.6384Z",
    fill: "#FFEB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3062 58.2655L32.6173 54.9422C31.3898 54.2775 29.7139 54.3986 27.8727 55.4688C27.7158 55.559 27.5617 55.6575 27.4075 55.7589C23.8709 58.0881 21.0853 63.1097 21.0965 67.2667C21.1021 69.379 21.8307 70.8801 23.0133 71.6068L28.7023 74.9301L38.309 65.1572V58.2683L38.3062 58.2655Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5617 58.7922C33.4048 58.8823 33.2506 58.9809 33.0965 59.0823C29.5598 61.4114 26.7742 66.433 26.7854 70.59C26.791 72.7023 27.5197 74.2035 28.7023 74.9301C29.9438 75.6961 31.6841 75.6088 33.6065 74.4935C36.7144 72.6911 39.3291 68.7594 40.1278 64.9995C40.2931 64.2194 40.3828 63.4448 40.38 62.7013C40.3688 58.3641 37.3142 56.6151 33.5617 58.795V58.7922Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.552 70.2803V77.172L85.5244 59.0823V52.1934L54.552 70.2803Z",
    fill: "#FFBE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4675 54.8718L101.156 58.1951V51.3062C101.156 47.4816 95.4675 47.9829 95.4675 47.9829V54.8718Z",
    fill: "#D28800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0681 54.4663L92.3792 51.1429C91.1518 50.4782 89.4759 50.5994 87.6347 51.6696C87.4778 51.7597 87.3236 51.8583 87.1695 51.9597C83.6328 54.2888 80.8472 59.3104 80.8584 63.4674C80.864 65.5797 81.5927 67.0809 82.7753 67.8075L88.4642 71.1308L98.071 61.358V54.4691L98.0681 54.4663Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3237 54.9901C93.1667 55.0802 93.0126 55.1788 92.8585 55.2802C89.3218 57.6093 86.5362 62.631 86.5474 66.788C86.553 68.9003 87.2816 70.4014 88.4643 71.128C89.7057 71.8941 91.446 71.8068 93.3685 70.6915C96.4764 68.889 99.0911 64.9573 99.8898 61.1974C100.055 60.4173 100.145 59.6428 100.142 58.8993C100.131 54.562 97.0761 52.813 93.3237 54.9929V54.9901Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5637 64.1344C96.7939 62.0068 96.7974 59.7017 95.5716 58.9859C94.3458 58.27 92.3548 59.4145 91.1247 61.5421C89.8945 63.6697 89.8909 65.9748 91.1167 66.6906C92.3425 67.4065 94.3335 66.262 95.5637 64.1344Z",
    fill: "#8D8F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5866 64.1884C92.1522 64.4391 91.7599 64.4644 91.4768 64.2983C91.1966 64.1349 91.0228 63.7857 91.02 63.29C91.02 62.293 91.715 61.082 92.5782 60.5806C92.9789 60.3469 93.346 60.3103 93.6263 60.437C93.9429 60.5834 94.1447 60.9468 94.1475 61.4762C94.1475 62.4732 93.4525 63.6871 92.5894 64.1856L92.5866 64.1884Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4739 64.2982L92.5108 64.4785L94.2679 61.2368L93.6205 60.437L91.4739 64.2982Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3489 64.3518C92.6259 64.7714 92.0402 64.4334 92.0374 63.5998C92.0374 62.7661 92.6175 61.7494 93.3405 61.3298C93.702 61.1214 94.0299 61.0988 94.2653 61.2368C94.5035 61.372 94.6492 61.6649 94.652 62.0818C94.652 62.9154 94.0691 63.9321 93.3489 64.3518Z",
    fill: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1732 58.8345C95.5179 59.2175 95.7225 59.8033 95.7225 60.5609C95.7281 62.5662 94.3241 65.008 92.5894 66.0163C91.9028 66.4134 91.2694 66.5261 90.751 66.3937C91.3199 67.0246 92.2727 67.1006 93.3544 66.4725C95.0891 65.4643 96.4932 63.0225 96.4875 61.0172C96.4847 59.8033 95.9635 59.0344 95.1704 58.8317L95.1732 58.8345Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7948 37.8608C93.9653 37.4468 92.8528 37.5454 91.6309 38.2551L85.9448 41.5559C84.1764 42.5811 82.7724 44.1329 81.9205 45.9974L74.3007 65.6558C73.4123 67.6075 75.7271 71.4519 75.7271 71.4519L78.8602 70.8577C78.8602 70.8577 92.9452 49.8192 92.948 49.822C92.9677 49.8305 92.9845 49.8389 93.0013 49.8502C93.0069 49.8502 93.0125 49.8558 93.0153 49.8586C93.0321 49.8671 93.0489 49.8755 93.0657 49.884C93.0713 49.8868 93.077 49.8896 93.0854 49.8924C93.0994 49.9009 93.1162 49.9093 93.1302 49.9178C93.1386 49.9206 93.1442 49.9262 93.1526 49.929C93.1666 49.9375 93.1806 49.9459 93.1919 49.9516C93.2003 49.9572 93.2087 49.9628 93.2171 49.9657C93.2283 49.9741 93.2423 49.9797 93.2535 49.9882C93.2647 49.9938 93.2731 49.9995 93.2843 50.0079C93.2955 50.0135 93.3068 50.022 93.3152 50.0276C93.3264 50.0361 93.3376 50.0417 93.3488 50.0502C93.3572 50.0558 93.3684 50.0614 93.3768 50.0699C93.388 50.0783 93.402 50.0868 93.4132 50.0952C93.4216 50.1008 93.4301 50.1065 93.4385 50.1121C93.4497 50.1206 93.4637 50.129 93.4777 50.1375C93.4861 50.1431 93.4917 50.1487 93.5001 50.1544C93.5141 50.1628 93.5253 50.1741 93.5394 50.1825C93.545 50.1882 93.5534 50.191 93.559 50.1966C93.573 50.2079 93.587 50.2191 93.601 50.2304C93.6066 50.236 93.6122 50.2388 93.6178 50.2445C93.6318 50.2557 93.6486 50.267 93.6627 50.2811C93.6683 50.2839 93.6711 50.2895 93.6767 50.2924C93.6907 50.3036 93.7075 50.3177 93.7215 50.3318C93.7243 50.3346 93.7299 50.3374 93.7327 50.3402C93.7495 50.3543 93.7635 50.3684 93.7804 50.3825C93.8056 50.405 93.8224 50.4191 93.8392 50.436C93.8644 50.4585 93.8812 50.4754 93.8981 50.4895C93.9205 50.512 93.9373 50.5289 93.9541 50.5458C93.9765 50.5684 93.9933 50.5853 94.0102 50.6022C94.0326 50.6247 94.0494 50.6416 94.0634 50.6585C94.083 50.681 94.0998 50.6979 94.1166 50.7176C94.1363 50.7373 94.1503 50.7571 94.1643 50.774C94.8733 50.0614 100.481 41.187 100.481 41.187L94.792 37.8636L94.7948 37.8608Z",
    fill: "#FFDE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9895 68.9763L74.3006 65.653L62.522 72.4883L68.2109 75.8117L79.9895 68.9763Z",
    fill: "#FFEB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8101 79.0392L67.499 82.3626V75.4737C67.499 71.649 61.8101 72.1503 61.8101 72.1503V79.0392Z",
    fill: "#D28800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8228 73.7557L59.1339 70.4323C57.9064 69.7677 56.2305 69.8888 54.3893 70.959C54.2324 71.0491 54.0783 71.1477 53.9241 71.2491C50.3875 73.5782 47.6019 78.5999 47.6131 82.7569C47.6187 84.8692 48.3473 86.3703 49.5299 87.0969L55.2189 90.4203L64.8256 80.6474V73.7585L64.8228 73.7557Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0783 74.2823C59.9214 74.3725 59.7672 74.471 59.6131 74.5724C56.0764 76.9016 53.2908 81.9232 53.302 86.0802C53.3076 88.1925 54.0363 89.6936 55.2189 90.4203C56.4604 91.1863 58.2007 91.099 60.1231 89.9837C63.231 88.1812 65.8457 84.2495 66.6444 80.4897C66.8097 79.7095 66.8994 78.935 66.8966 78.1915C66.8854 73.8542 63.8308 72.1053 60.0783 74.2852V74.2823Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3176 83.4241C63.5478 81.2965 63.5513 78.9914 62.3255 78.2756C61.0997 77.5598 59.1087 78.7042 57.8786 80.8318C56.6484 82.9594 56.6448 85.2645 57.8706 85.9803C59.0964 86.6962 61.0874 85.5517 62.3176 83.4241Z",
    fill: "#8D8F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3385 83.4779C58.9042 83.7285 58.5118 83.7539 58.2288 83.5877C57.9485 83.4244 57.7748 83.0751 57.772 82.5794C57.7692 81.5824 58.467 80.3714 59.3301 79.8701C59.7309 79.6363 60.098 79.5997 60.3782 79.7264C60.6949 79.8729 60.8967 80.2362 60.8995 80.7657C60.9023 81.7627 60.2045 82.9765 59.3413 83.4751L59.3385 83.4779Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2288 83.5877L59.2657 83.768L61.02 80.5291L60.3754 79.7264L58.2288 83.5877Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1035 83.6441C59.3805 84.0637 58.7948 83.7258 58.792 82.8921C58.792 82.0585 59.3721 81.0417 60.0951 80.6221C60.4566 80.4137 60.7845 80.3911 61.0199 80.5263C61.2581 80.6615 61.4039 80.9544 61.4067 81.3713C61.4067 82.2049 60.8238 83.2216 60.1035 83.6413V83.6441Z",
    fill: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9278 78.1239C62.2725 78.5069 62.4771 79.0927 62.4771 79.8504C62.4827 81.8556 61.0787 84.2974 59.344 85.3057C58.6574 85.7028 58.0241 85.8155 57.5056 85.6831C58.0745 86.314 59.0273 86.39 60.1091 85.762C61.8438 84.7537 63.2478 82.3119 63.2422 80.3066C63.2394 79.0928 62.7181 78.3239 61.925 78.1211L61.9278 78.1239Z",
    fill: "#70747A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8205 68.5144C59.8205 68.5144 59.8037 68.5088 59.7981 68.506C59.1339 68.1173 33.587 53.1482 33.3068 53.0271C31.8523 52.399 29.9438 52.6074 27.8672 53.8128L23.6748 56.2434L55.8831 75.0541L59.4394 73.3642C60.4567 72.8798 61.5356 72.5362 62.6426 72.3419L65.5067 71.8378C65.5067 71.8378 60.1064 68.6383 59.8233 68.5144H59.8205Z",
    fill: "#FFEB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0728 72.6207C62.1494 71.4153 64.0523 71.2069 65.5067 71.8349C66.8995 72.4376 67.8804 73.8064 68.2111 75.8089C68.2895 76.2877 68.3316 76.803 68.3344 77.3522L68.3428 80.363L68.3484 81.8697L67.5021 82.3598L67.4965 79.9912L67.4908 77.8423C67.4768 73.1361 64.1504 71.2322 60.0784 73.5952L59.6132 73.8655L55.886 76.0257V75.0484L60.0756 72.6179L60.0728 72.6207Z",
    fill: "#FFCC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.961 44.2343C101.952 41.2827 99.8756 40.0914 97.3198 41.5756L91.6336 44.8764C89.8653 45.9016 88.4613 47.4534 87.6094 49.3179L79.9895 68.9763L68.2109 75.8117C68.2894 76.2904 68.3427 80.3686 68.3427 80.3686L85.544 70.3873L85.5356 67.6047C85.5215 62.7492 88.8424 56.6377 92.934 54.0579C93.1245 53.9396 93.2955 53.8354 93.472 53.7368C95.459 52.6299 97.2665 52.4807 98.6285 53.1425C98.6565 53.1566 98.6733 53.1651 98.6902 53.1735C98.6958 53.1735 98.7014 53.1791 98.7042 53.182C98.721 53.1904 98.7378 53.1989 98.7546 53.2073C98.7602 53.2101 98.7658 53.2129 98.7742 53.2158C98.7882 53.2242 98.8051 53.2326 98.8191 53.2411C98.8275 53.2439 98.8331 53.2495 98.8415 53.2524C98.8555 53.2608 98.8695 53.2693 98.8807 53.2749C98.8891 53.2805 98.8975 53.2862 98.9059 53.2918C98.9172 53.3002 98.9312 53.3059 98.9424 53.3143C98.9536 53.32 98.962 53.3256 98.9732 53.334C98.9844 53.3397 98.9956 53.3481 99.004 53.3538C99.0152 53.3622 99.0264 53.3678 99.0377 53.3763C99.0461 53.3819 99.0573 53.3876 99.0657 53.396C99.0769 53.4044 99.0909 53.4129 99.1021 53.4213C99.1105 53.427 99.1189 53.4326 99.1273 53.4382C99.1413 53.4467 99.1526 53.4551 99.1666 53.4636C99.175 53.4692 99.1834 53.4749 99.189 53.4805C99.203 53.4889 99.2142 53.5002 99.2282 53.5087C99.2338 53.5143 99.2422 53.5171 99.2478 53.5227C99.2619 53.534 99.2759 53.5453 99.2899 53.5565C99.2955 53.5622 99.3011 53.565 99.3067 53.5706C99.3207 53.5819 99.3375 53.5931 99.3515 53.6072C99.3571 53.61 99.3599 53.6157 99.3655 53.6185C99.3796 53.6298 99.3964 53.6438 99.4104 53.6579C99.4132 53.6607 99.4188 53.6636 99.4216 53.6664C99.4384 53.6805 99.4524 53.6945 99.4692 53.7086C99.4945 53.7312 99.5113 53.7452 99.5281 53.7621C99.5533 53.7847 99.5701 53.8016 99.5869 53.8156C99.6093 53.8382 99.6262 53.8551 99.643 53.872C99.6654 53.8945 99.6822 53.9114 99.699 53.9283C99.7215 53.9508 99.7383 53.9677 99.7523 53.9874C99.7719 54.01 99.7887 54.0269 99.8055 54.0466C99.8251 54.0691 99.842 54.0888 99.8588 54.1085C99.8784 54.1311 99.8952 54.1508 99.912 54.1705C99.9456 54.2128 99.9793 54.255 100.013 54.2972C100.307 54.6859 100.551 55.1422 100.739 55.6632C100.75 55.6942 100.758 55.7223 100.77 55.7505C100.781 55.7815 100.789 55.8096 100.798 55.8378C100.809 55.8688 100.817 55.897 100.826 55.9279C100.834 55.9589 100.842 55.9871 100.854 56.0181C100.865 56.0519 100.873 56.0828 100.882 56.111C100.89 56.142 100.898 56.173 100.907 56.2011C100.915 56.2377 100.924 56.2659 100.932 56.2969C100.941 56.3307 100.946 56.3617 100.955 56.3898C100.963 56.4264 100.969 56.4546 100.974 56.4828C100.983 56.5222 100.988 56.5504 100.994 56.5813C101.002 56.6236 101.008 56.6518 101.013 56.6799C101.022 56.7193 101.027 56.7503 101.03 56.7785C101.03 56.7841 101.03 56.7898 101.03 56.7954C101.036 56.8236 101.039 56.8489 101.044 56.8771C101.044 56.8827 101.044 56.8911 101.047 56.8968C101.05 56.9221 101.055 56.9503 101.058 56.9785C101.058 56.9869 101.058 56.9925 101.061 57.001C101.064 57.0263 101.069 57.0545 101.072 57.0798C101.072 57.0883 101.072 57.0967 101.075 57.1052C101.078 57.1305 101.081 57.1587 101.086 57.184C101.086 57.1925 101.086 57.2009 101.089 57.2094C101.092 57.2347 101.095 57.2629 101.097 57.2911C101.097 57.2995 101.097 57.308 101.1 57.3164C101.1 57.3418 101.106 57.3671 101.109 57.3953C101.109 57.4065 101.109 57.415 101.111 57.4234C101.111 57.4488 101.117 57.477 101.12 57.5023C101.12 57.5107 101.12 57.522 101.12 57.5305C101.12 57.5558 101.123 57.5812 101.125 57.6065C101.125 57.6178 101.125 57.629 101.125 57.6403C101.125 57.6628 101.128 57.6826 101.131 57.7051C101.131 57.722 101.131 57.7361 101.134 57.753C101.134 57.7755 101.134 57.7952 101.137 57.8177C101.137 57.8318 101.137 57.8487 101.137 57.8628C101.137 57.8881 101.137 57.9135 101.139 57.9388C101.139 57.9501 101.139 57.9642 101.139 57.9755C101.139 58.0008 101.139 58.0261 101.139 58.0487C101.139 58.0628 101.139 58.074 101.139 58.0881C101.139 58.1135 101.139 58.1416 101.139 58.167C101.139 58.1782 101.139 58.1895 101.139 58.2008C101.139 58.2402 101.139 58.2768 101.139 58.3162L101.98 57.829L101.941 44.2427L101.961 44.2343Z",
    fill: "#FFBE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6775 56.2433V57.2178L55.883 76.0285V75.054L23.6775 56.2433Z",
    fill: "#FFD554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1106 70.3901L59.5515 68.9622L60.4287 63.4308L58.6351 64.4785L57.1106 70.3901Z",
    fill: "#FFBE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6039 49.8615L32.0793 55.7702L57.1106 70.3901L58.6352 64.4785L33.6039 49.8615Z",
    fill: "#FFD554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7976 48.8419L60.5575 63.8871L58.7135 64.9629L32.9536 49.9206L34.7976 48.8419Z",
    fill: "#FFEB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0806 62.7464L60.8742 61.6988L37.0423 47.783L35.2488 48.8307L59.0806 62.7464Z",
    fill: "#8E9095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5084 41.125L86.309 40.4237L86.2473 18.0616L87.4468 18.7629L87.5084 41.125Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6957 29.6398L87.4468 18.7629L87.5084 41.125L88.6098 40.4857L88.5425 16.8505L67.8242 28.8709L58.635 64.4785L60.4286 63.4308L68.6957 29.6398Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7751 63.9631L57.5757 63.2618L66.6247 28.1724L67.8242 28.8709L58.7751 63.9631Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8242 28.8709L66.6248 28.1724L87.3431 16.1492L88.5426 16.8505L67.8242 28.8709Z",
    fill: "#1A1E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.671 27.2036L62.4716 26.5023L62.4099 4.14014L63.6094 4.84142L63.671 27.2036Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7079 2.92908L43.9868 14.9494L35.2488 48.8306L37.0423 47.7829L44.8583 15.7211L63.6094 4.84141L63.671 27.2036L64.7724 26.5642L64.7079 2.92908Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9377 50.0417L34.0213 49.5066L33.7383 49.3404L42.7873 14.251L43.9868 14.9494L34.9377 50.0417Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9868 14.9494L42.7874 14.251L63.5085 2.22778L64.708 2.92906L43.9868 14.9494Z",
    fill: "#1A1E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0493 48.1293L33.6038 49.8614L58.6351 64.4785L59.0806 62.7464L34.0493 48.1293Z",
    fill: "#4E5159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2517 27.0994L46.5483 30.9888L46.6492 82.8921L50.0009 80.9488L49.9056 30.817L53.2517 28.8596V27.0994Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6491 82.8921L44.5473 81.6641L44.4492 29.7637L46.5482 30.9888L46.6491 82.8921Z",
    fill: "#66696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1929 22.2158L47.801 29.5778V27.8176L35.1929 20.4555V22.2158Z",
    fill: "#66696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1928 20.4555L35.2937 72.3588L31.9391 74.3021L31.8411 22.3988L35.1928 20.4555Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9392 74.3021L29.8401 73.077L29.7393 21.1737L31.8411 22.3988L31.9392 74.3021Z",
    fill: "#66696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2516 27.0994L36.4455 17.2842L29.7393 21.1737L31.8411 22.3988L35.1928 20.4555L47.8009 27.8175L44.4492 29.7637L46.5482 30.9888L49.8999 29.0455L53.2516 27.0994Z",
    fill: "#8E9095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4753 47.2309L21.699 47.6844C21.6458 47.7154 21.5981 47.7548 21.5533 47.7942C21.5421 47.8055 21.5309 47.8139 21.5225 47.8252C21.4804 47.8703 21.4384 47.9181 21.4048 47.9716C21.3796 48.0111 21.3571 48.0505 21.3375 48.0927C21.3347 48.1012 21.3319 48.104 21.3319 48.1068C21.3207 48.135 21.3067 48.1603 21.2983 48.1885C21.2927 48.2026 21.2899 48.2167 21.2843 48.2308C21.2843 48.2392 21.2787 48.2476 21.2759 48.2561C21.2759 48.2645 21.2703 48.2702 21.2675 48.2786C21.259 48.3068 21.2506 48.3378 21.245 48.3659C21.245 48.3772 21.2422 48.3885 21.2394 48.3969C21.2394 48.4026 21.2394 48.411 21.2366 48.4166C21.2366 48.4279 21.231 48.4363 21.231 48.4476C21.2254 48.4758 21.2226 48.5011 21.2198 48.5293C21.2198 48.5434 21.217 48.5603 21.2142 48.5744C21.2142 48.58 21.2142 48.5856 21.2142 48.5912C21.2142 48.5969 21.2142 48.6053 21.2142 48.611C21.2142 48.6363 21.2114 48.6645 21.2086 48.6926C21.2086 48.7208 21.2086 48.749 21.2086 48.7743C21.2086 48.7799 20.068 68.8327 20.068 68.8327L19.4207 75.347L21.1385 76.344L22.6883 75.4399L22.7331 59.716L22.7611 47.8759C22.7611 47.8111 22.764 47.7463 22.7696 47.6872C22.7696 47.6816 22.7696 47.6759 22.7696 47.6703C22.7752 47.614 22.7836 47.5605 22.792 47.5098C22.792 47.5041 22.792 47.4957 22.7948 47.49C22.806 47.4393 22.8172 47.3915 22.8312 47.3464C22.8312 47.338 22.8368 47.3295 22.8396 47.3211C22.8536 47.2788 22.8704 47.2366 22.8873 47.1971C22.9125 47.1408 22.9349 47.0986 22.9601 47.0591C22.9966 47.0028 23.0358 46.9549 23.0778 46.9099C23.089 46.8986 23.1002 46.8901 23.1086 46.8789C23.1535 46.8366 23.2011 46.7972 23.2544 46.769L22.4781 47.2225L22.4753 47.2309Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 59.6991L22.5791 59.1583L49.219 74.6034L48.2914 75.1442L21.6543 59.6991Z",
    fill: "#585A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3545 69.0917L46.0271 68.6833V72.891L45.4386 73.2346L45.3545 73.2966V69.0917Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5558 69.6353L44.553 72.8432L45.3545 73.2966V70.0888L44.5558 69.6353Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2712 66.726L41.9466 66.3204V70.5253L41.3553 70.8689L41.2712 70.9309V66.726Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4755 67.2695L40.4727 70.4802L41.2714 70.9308V67.723L40.4755 67.2695Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1909 64.3602L37.8663 63.9547V68.1595L37.275 68.5031L37.1909 68.5651V64.3602Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3923 64.9037V68.1144L37.191 68.5651V65.3572L36.3923 64.9037Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1106 61.9944L33.786 61.5889V65.7937L33.1947 66.1402L33.1106 66.2021V61.9944Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3119 62.5408L32.3091 65.7487L33.1106 66.2021V62.9915L32.3119 62.5408Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0303 59.6315L29.7057 59.2231V63.428L29.1143 63.7744L29.0303 63.8363V59.6315Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2316 60.175L28.2288 63.3829L29.0303 63.8364V60.6257L28.2316 60.175Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.95 57.2657L25.6253 56.8574V61.0651L25.034 61.4086L24.95 61.4706V57.2657Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1512 57.8093L24.1484 61.0171L24.9499 61.4706V58.2627L24.1512 57.8093Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 55.5618L22.5791 55.0211L49.219 70.469L48.2914 71.0069L21.6543 55.5618Z",
    fill: "#585A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5558 60.1469L44.553 68.6834L45.3545 69.134V60.5975L44.5558 60.1469Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3545 59.6005L46.0495 59.1949L46.0271 68.7284L45.4386 69.0748L45.3545 69.134V59.6005Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.95 47.7745L25.645 47.3689L25.6253 56.9024L25.034 57.2488L24.95 57.3079V47.7745Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1512 48.3209L24.1484 56.8573L24.9499 57.308V48.7715L24.1512 48.3209Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0303 50.1402L29.7253 49.7347L29.7057 59.2682L29.1143 59.6118L29.0303 59.6737V50.1402Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2316 50.6838L28.2288 59.2231L29.0303 59.6737V51.1372L28.2316 50.6838Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1106 52.506L33.8056 52.1005L33.786 61.6339L33.1947 61.9775L33.1106 62.0395V52.506Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3119 53.0496L32.3091 61.586L33.1106 62.0395V53.503L32.3119 53.0496Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1909 54.8718L37.8887 54.4634L37.8663 63.9969L37.275 64.3433L37.1909 64.4053V54.8718Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3923 55.4154V63.9519L37.191 64.4053V55.8688L36.3923 55.4154Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2712 57.2347L41.969 56.8292L41.9466 66.3627L41.3553 66.7091L41.2712 66.771V57.2347Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4755 57.7811L40.4727 66.3176L41.2714 66.7711V58.2317L40.4755 57.7811Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 70.9506L22.5791 70.4099L49.1265 85.8155L48.2017 86.3563L21.6543 70.9506Z",
    fill: "#585A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1792 86.9984L49.7317 86.0915L49.7233 88.4347L48.1736 89.3388L48.1792 86.9984Z",
    fill: "#4F5156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1755 50.098L29.7253 49.1911L30.5044 49.6445L28.9546 50.5514L28.1755 50.098Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9547 50.5515L30.5045 49.6446V50.3966L28.9519 51.3034L28.9547 50.5515Z",
    fill: "#2B2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 63.9181L22.5791 63.3773L49.1265 78.783L48.2017 79.3209L21.6543 63.9181Z",
    fill: "#585A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.281 52.4807L33.8307 51.5738L34.6126 52.0272L33.0629 52.9341L32.281 52.4807Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0629 52.9341L34.6126 52.0272L34.6098 52.7792L33.0601 53.6861L33.0629 52.9341Z",
    fill: "#2B2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2017 79.1519L49.7514 78.2479L49.7458 80.5883L48.196 81.4924L48.2017 79.1519Z",
    fill: "#4F5156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 63.918V66.2641L48.1961 81.6641L48.2017 79.3209L21.6543 63.918Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3894 54.8634L37.9419 53.9593L38.721 54.4127L37.1713 55.3168L36.3894 54.8634Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1713 55.3168L38.721 54.4127L38.7182 55.1647L37.1685 56.0688L37.1713 55.3168Z",
    fill: "#2B2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2797 57.7023L42.8294 56.7954L42.8266 57.5474L41.2769 58.4543L41.2797 57.7023Z",
    fill: "#2B2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4978 57.2488L42.0475 56.3419L42.8294 56.7954L41.2797 57.7022L40.4978 57.2488Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3853 60.0849L46.9378 59.178L46.935 59.93L45.3853 60.8369V60.0849Z",
    fill: "#2B2E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6062 59.6315L46.1559 58.7246L46.9378 59.178L45.3853 60.0849L44.6062 59.6315Z",
    fill: "#303336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5343 59.5188C48.4259 60.6172 49.9616 63.2871 49.956 65.4755L49.8832 93.0395L48.1653 92.0425L48.1737 89.3416L48.1793 87.0012L48.1961 81.4979L48.2017 79.1575L48.2101 76.3158V75.4145L48.2185 72.9361V72.0349L48.2353 64.4841C48.2381 63.3913 47.4703 62.0564 46.5258 61.5072L22.9182 47.8082C21.9738 47.2591 21.2003 47.7012 21.1975 48.794L21.1246 76.358L19.4067 75.361L19.4796 47.797C19.4852 45.6115 21.0321 44.7271 22.9238 45.8255L46.5314 59.5244L46.5343 59.5188Z",
    fill: "#323436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5029 64.4137C51.5029 64.3574 51.4973 64.3039 51.4945 64.2476C51.4916 64.1912 51.486 64.1377 51.4804 64.0814C51.4748 64.0251 51.4692 63.9687 51.4608 63.9124C51.4524 63.8561 51.4468 63.7969 51.4356 63.7406C51.4272 63.6815 51.416 63.6251 51.4048 63.566C51.3936 63.5068 51.3824 63.4477 51.3683 63.3857C51.3543 63.3266 51.3403 63.2646 51.3263 63.2055C51.3123 63.1435 51.2955 63.0844 51.2787 63.0224C51.2618 62.9605 51.245 62.9013 51.2254 62.8394C51.2086 62.7802 51.189 62.7211 51.1694 62.6619C51.1498 62.6028 51.1301 62.5436 51.1077 62.4873C51.0881 62.431 51.0657 62.3747 51.0433 62.3183C51.0208 62.262 50.9984 62.2057 50.976 62.1493C50.9536 62.093 50.9284 62.0395 50.9059 61.9832C50.8807 61.9268 50.8555 61.8705 50.8303 61.817C50.8023 61.755 50.7742 61.6959 50.7434 61.6368C50.7098 61.5664 50.6733 61.4988 50.6369 61.4312C50.5809 61.327 50.5248 61.2256 50.466 61.127C50.3847 60.989 50.3006 60.851 50.2109 60.7186C50.1409 60.6116 50.068 60.5074 49.9923 60.406C49.9419 60.3384 49.8915 60.2708 49.8382 60.2032C49.7962 60.1469 49.7513 60.0934 49.7065 60.0399C49.6617 59.9864 49.6196 59.9357 49.5748 59.885C49.5299 59.8343 49.4851 59.7836 49.4403 59.7357C49.3926 59.685 49.3478 59.6371 49.3001 59.5864C49.2525 59.5385 49.2049 59.4907 49.1544 59.4428C49.104 59.3949 49.0535 59.347 49.0031 59.302C48.9526 59.2569 48.9022 59.2118 48.8518 59.1696C48.8013 59.1274 48.7509 59.0851 48.7004 59.0457C48.65 59.0062 48.5995 58.9668 48.5491 58.9302C48.4987 58.8936 48.451 58.857 48.4006 58.8232C48.3529 58.7894 48.3053 58.7584 48.2548 58.7274C48.2072 58.6964 48.1596 58.6683 48.1091 58.6373C48.0979 58.6317 48.0867 58.6232 48.0755 58.6176L24.4678 44.9187C24.4314 44.8989 24.395 44.8764 24.3585 44.8567C24.3109 44.8314 24.2661 44.806 24.2184 44.7835C24.1708 44.7609 24.1259 44.7384 24.0811 44.7187C24.0363 44.699 23.9886 44.6793 23.9438 44.6596C23.8961 44.6398 23.8513 44.6229 23.8065 44.606C23.7616 44.5891 23.714 44.5751 23.6691 44.561C23.6215 44.5469 23.5739 44.5328 23.5262 44.5215C23.4786 44.5103 23.4309 44.499 23.3861 44.4906C23.3356 44.4793 23.2852 44.4737 23.2348 44.4652C23.1843 44.4596 23.1311 44.454 23.0834 44.4483C23.0302 44.4455 22.9741 44.4427 22.9209 44.4427C22.8592 44.4427 22.8004 44.4455 22.7415 44.4511C22.6743 44.4568 22.607 44.468 22.5426 44.4793C22.4585 44.4962 22.38 44.5187 22.3016 44.5469C22.2035 44.5807 22.111 44.6258 22.0241 44.6764L20.4744 45.5805C20.5612 45.5298 20.6565 45.4848 20.7518 45.451C20.8303 45.4228 20.9087 45.4003 20.9928 45.3834C21.0573 45.3693 21.1245 45.3608 21.1918 45.3552C21.2506 45.3496 21.3095 45.3467 21.3711 45.3467C21.4244 45.3467 21.4776 45.3467 21.5337 45.3524C21.5841 45.3552 21.6346 45.3608 21.685 45.3693C21.7355 45.3749 21.7859 45.3834 21.8363 45.3946C21.884 45.4031 21.9288 45.4143 21.9765 45.4256C22.0241 45.4369 22.0718 45.451 22.1194 45.465C22.1642 45.4791 22.2119 45.4932 22.2567 45.5101C22.3015 45.527 22.3492 45.5439 22.394 45.5636C22.4389 45.5805 22.4837 45.6002 22.5313 45.6228C22.5762 45.6425 22.6238 45.665 22.6687 45.6875C22.7163 45.7101 22.7611 45.7354 22.8088 45.7608C22.8452 45.7805 22.8817 45.8002 22.9181 45.8227L46.5257 59.5216C46.5257 59.5216 46.5482 59.5357 46.5594 59.5414C46.607 59.5695 46.6575 59.6005 46.7051 59.6315C46.7527 59.6625 46.8032 59.6935 46.8508 59.7272C46.9013 59.761 46.9517 59.7977 46.9994 59.8343C47.0498 59.8709 47.1002 59.9103 47.1507 59.9497C47.2011 59.9892 47.2516 60.0314 47.302 60.0737C47.3525 60.1159 47.4029 60.161 47.4534 60.206C47.5038 60.2511 47.5542 60.299 47.6047 60.3469C47.6523 60.3947 47.7028 60.4426 47.7504 60.4905C47.798 60.5384 47.8457 60.5891 47.8905 60.6398C47.9354 60.6876 47.9802 60.7383 48.025 60.789C48.0699 60.8397 48.1147 60.8932 48.1568 60.9439C48.2016 60.9974 48.2464 61.051 48.2885 61.1073C48.3417 61.1749 48.3922 61.2396 48.4426 61.3101C48.5183 61.4114 48.5911 61.5157 48.6612 61.6227C48.7509 61.755 48.8349 61.8931 48.9162 62.0311C48.9751 62.1324 49.0311 62.2338 49.0872 62.3352C49.1236 62.4028 49.16 62.4732 49.1937 62.5408C49.2245 62.6 49.2525 62.6619 49.2805 62.7211C49.3058 62.7774 49.331 62.8309 49.3562 62.8872C49.3814 62.9407 49.4038 62.9971 49.4263 63.0534C49.4487 63.1097 49.4711 63.1661 49.4935 63.2224C49.5159 63.2787 49.5356 63.335 49.558 63.3914C49.5804 63.4505 49.6 63.5097 49.6196 63.566C49.6392 63.6251 49.6589 63.6843 49.6757 63.7434C49.6953 63.8054 49.7121 63.8645 49.7289 63.9265C49.7457 63.9884 49.7625 64.0476 49.7766 64.1096C49.7906 64.1687 49.8046 64.2307 49.8186 64.2898C49.8326 64.3489 49.8438 64.4109 49.855 64.4701C49.8662 64.5292 49.8746 64.5855 49.8859 64.6447C49.8943 64.701 49.9027 64.7601 49.9111 64.8165C49.9195 64.8728 49.9251 64.9291 49.9307 64.9855C49.9363 65.0418 49.9391 65.0981 49.9447 65.1516C49.9475 65.2079 49.9503 65.2615 49.9531 65.3178C49.9531 65.3685 49.9531 65.422 49.9531 65.4727L49.8803 93.0367L51.43 92.1327L51.5029 64.5686C51.5029 64.5179 51.5029 64.4644 51.5029 64.4137Z",
    fill: "url(#paint9_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 70.9506V73.2966L48.1961 88.6966L48.2017 86.3562L21.6543 70.9506Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55 73.5304L40.0998 72.6235L43.6028 74.6569L42.0363 75.5638L38.55 73.5304Z",
    fill: "#8E9095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0362 75.5638L39.8167 76.4115L40.0465 90.5217C40.0465 91.7186 39.4019 92.8227 38.3622 93.4085C38.3622 93.4085 18.2969 106.561 15.1301 107.631C14.8751 107.716 14.6649 107.778 14.4968 107.806C14.4771 107.809 14.4575 107.811 14.4379 107.814C14.4183 107.817 14.4015 107.82 14.3819 107.823C14.365 107.823 14.3482 107.826 14.3314 107.828C14.3146 107.828 14.3006 107.828 14.2838 107.828C14.2698 107.828 14.2558 107.828 14.2417 107.828C14.2277 107.828 14.2165 107.828 14.2053 107.826C14.1941 107.826 14.1829 107.823 14.1717 107.82C14.1605 107.82 14.1521 107.814 14.1437 107.811C14.1352 107.809 14.1296 107.806 14.124 107.8C14.1072 107.789 14.0932 107.778 14.0848 107.761C14.0764 107.747 14.0708 107.727 14.0708 107.707L14.0652 108.879C14.0652 108.918 14.082 108.949 14.1184 108.972C14.124 108.975 14.1324 108.977 14.138 108.983C14.1465 108.986 14.1577 108.989 14.1661 108.992C14.1773 108.992 14.1885 108.997 14.1997 108.997C14.2109 108.997 14.2249 109 14.2361 109C14.2501 109 14.2642 109 14.2782 109C14.2922 109 14.309 109 14.3258 109C14.3426 109 14.3594 109 14.3763 108.994C14.3931 108.994 14.4127 108.989 14.4323 108.986C14.4519 108.983 14.4715 108.98 14.4912 108.977C14.6565 108.946 14.8695 108.887 15.1245 108.803C18.2128 107.761 27.8699 102.565 34.7275 98.7821C38.4771 96.7149 41.4057 95.0617 41.8485 94.811C42.8882 94.228 43.6 93.124 43.6 91.9242V74.6569L42.0334 75.561L42.0362 75.5638Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5501 73.5303V89.5612C38.5501 90.7582 37.9055 91.8622 36.8658 92.448L33.9905 94.2674C26.6314 98.7765 13.1208 107.217 14.1269 107.8C15.4665 108.578 39.0265 95.2335 40.3549 94.4815C41.3946 93.8985 42.0391 92.7945 42.0391 91.5947V75.5638L38.5501 73.5303Z",
    fill: "url(#paint10_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0115 65.2868L26.5612 64.3799L30.0671 66.4162L28.4977 67.3203L25.0115 65.2868Z",
    fill: "#8E9095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0671 66.4162L28.5006 67.3203L26.2811 68.168L26.5109 82.2781C26.5109 83.4751 25.8663 84.5791 24.8266 85.1649C24.8266 85.1649 4.76121 98.3175 1.59446 99.3877C1.33944 99.4722 1.12926 99.5313 0.961115 99.5623C0.941498 99.5651 0.921881 99.568 0.902264 99.5708C0.882647 99.5736 0.865832 99.5764 0.846215 99.5792C0.829401 99.5792 0.812586 99.582 0.795772 99.5849C0.778957 99.5849 0.764945 99.5849 0.748131 99.5849C0.734118 99.5849 0.720106 99.5849 0.706094 99.5849C0.692082 99.5849 0.680872 99.5849 0.669662 99.582C0.658453 99.582 0.647243 99.5792 0.636033 99.5764C0.624824 99.5764 0.616416 99.5708 0.608009 99.568C0.599602 99.5651 0.593997 99.5623 0.588392 99.5567C0.571577 99.5454 0.557565 99.5342 0.549158 99.5173C0.540751 99.5032 0.535146 99.4835 0.535146 99.4638L0.529541 100.635C0.529541 100.675 0.546356 100.706 0.582787 100.728C0.588392 100.731 0.596799 100.734 0.602404 100.74C0.610811 100.742 0.622021 100.745 0.630428 100.748C0.641638 100.748 0.652848 100.754 0.664058 100.754C0.675267 100.754 0.689279 100.756 0.700489 100.756C0.714501 100.756 0.728513 100.756 0.742526 100.756C0.756538 100.756 0.773352 100.756 0.790167 100.756C0.806981 100.756 0.823796 100.756 0.840611 100.751C0.857425 100.751 0.877042 100.745 0.896659 100.742C0.916276 100.74 0.935893 100.737 0.95551 100.734C1.12085 100.703 1.33384 100.644 1.58886 100.559C4.67714 99.5173 14.3343 94.3182 21.1919 90.5358C24.9415 88.477 27.87 86.8182 28.3128 86.5675C29.3525 85.9845 30.0643 84.8805 30.0643 83.6807V66.4134L30.0671 66.4162Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4979 67.3202L25.0088 65.2868V81.3177C25.0088 82.5147 24.3643 83.6187 23.3246 84.2045L20.4493 86.0239C13.0901 90.5329 -0.420413 98.9737 0.585659 99.5567C1.92522 100.334 25.4852 86.9899 26.8136 86.2379C27.8533 85.655 28.4979 84.5509 28.4979 83.3511V67.3202Z",
    fill: "url(#paint11_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 55.5618V56.5194L48.2858 71.9617L48.2914 71.0069L21.6543 55.5618Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 59.6991V60.6539L48.2858 76.0989L48.2914 75.1442L21.6543 59.6991Z",
    fill: "#37383C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9677 14.3946V13.7665C86.9677 13.7356 86.9677 13.7046 86.9621 13.6736C86.9257 13.4567 86.7659 13.2427 86.4801 13.0765L66.042 1.21669C65.9663 1.17444 65.8878 1.13501 65.8038 1.10122C65.7393 1.07587 65.6721 1.05334 65.602 1.03362C65.5459 1.01673 65.4871 1.00264 65.4282 0.991378C65.375 0.980112 65.319 0.971663 65.2629 0.963214C65.2097 0.954765 65.1564 0.949132 65.1004 0.946315C65.0471 0.940683 64.9911 0.937866 64.935 0.937866C64.879 0.937866 64.8201 0.937866 64.7641 0.937866C64.7024 0.937866 64.6408 0.943499 64.5791 0.949132C64.5063 0.957581 64.4362 0.96603 64.3661 0.980112C64.2568 0.999827 64.1531 1.02517 64.0523 1.05897C63.9205 1.10122 63.8 1.15473 63.6879 1.21951L53.3162 7.27756L53.3105 9.1561L63.6823 3.09804C63.7916 3.03326 63.9149 2.97975 64.0466 2.9375C64.1475 2.90371 64.254 2.87836 64.3605 2.85865C64.4306 2.84456 64.5006 2.83611 64.5735 2.82767C64.6352 2.82203 64.6968 2.8164 64.7585 2.8164C64.8145 2.8164 64.8734 2.8164 64.9294 2.8164C64.9855 2.8164 65.0387 2.82203 65.0948 2.82485C65.148 2.83048 65.2041 2.83611 65.2573 2.84175C65.3133 2.8502 65.3694 2.85865 65.4226 2.86991C65.4815 2.88118 65.5403 2.89526 65.5964 2.91216C65.6665 2.93187 65.7337 2.9544 65.7982 2.97975C65.8822 3.01355 65.9635 3.05298 66.0364 3.09522L86.4745 14.955C86.637 15.0508 86.7603 15.1606 86.8416 15.2761C86.9229 15.3944 86.9649 15.5183 86.9649 15.6422L86.9677 14.3918V14.3946Z",
    fill: "url(#paint12_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6537 9.20964L56.6481 11.091L55.6729 10.5249L55.6785 8.64636L56.6537 9.20964Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1969 2.97692L56.6537 9.71936L55.6785 9.15327L67.2217 2.41083L68.1969 2.97692Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.197 2.97693L68.1942 3.9345L56.6482 10.6741L56.6538 9.71937L68.197 2.97693Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6186 4.95972L71.613 5.91729L60.0698 12.6597L60.0754 11.7022L71.6186 4.95972Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0756 11.1952L60.07 13.0737L59.0947 12.5076L59.1003 10.6291L60.0756 11.1952Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6188 4.95971L60.0756 11.7022L59.1003 11.1361L70.6435 4.39362L71.6188 4.95971Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0376 6.94525L75.0348 7.90282L63.4888 14.6453L63.4944 13.6877L75.0376 6.94525Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4945 13.1807L63.4889 15.0593L62.5137 14.4932L62.5193 12.6146L63.4945 13.1807Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8149 13.9919C41.8149 13.9919 41.8009 14.0003 41.7953 14.0031C41.7813 14.0116 41.7673 14.0229 41.7532 14.0313C41.7336 14.0454 41.7112 14.0566 41.6944 14.0707C41.6776 14.082 41.6636 14.0961 41.6468 14.1073C41.6299 14.1214 41.6131 14.1355 41.5963 14.1496C41.5795 14.1637 41.5739 14.1693 41.5683 14.1778C41.5431 14.2031 41.5178 14.2284 41.4982 14.2538C41.4926 14.2594 41.487 14.2651 41.4842 14.2707C41.4786 14.2763 41.4758 14.282 41.473 14.2876C41.459 14.3073 41.445 14.327 41.4338 14.3467C41.4282 14.3552 41.4226 14.3636 41.417 14.3721C41.417 14.3749 41.4142 14.3805 41.4114 14.3862C41.4029 14.4031 41.3945 14.42 41.3861 14.4397C41.3805 14.4509 41.3749 14.4594 41.3721 14.4707C41.3637 14.4988 41.3581 14.5157 41.3553 14.5326C41.3525 14.5439 41.3469 14.5551 41.3469 14.5664C41.3413 14.5918 41.3413 14.6115 41.3385 14.6284C41.3385 14.6396 41.3357 14.6509 41.3357 14.6622C41.3357 14.6678 41.3357 14.6706 41.3357 14.6763L41.3301 16.5548C41.3301 16.5379 41.3301 16.521 41.3329 16.5069C41.3329 16.49 41.3329 16.4703 41.3385 16.4534C41.3385 16.4393 41.3441 16.4252 41.3497 16.4112C41.3553 16.3943 41.3581 16.3774 41.3637 16.3605C41.3693 16.3464 41.3749 16.3323 41.3805 16.3182C41.3889 16.3013 41.3945 16.2844 41.4057 16.2675C41.4113 16.2562 41.4198 16.2422 41.4282 16.2309C41.4394 16.2112 41.4534 16.1915 41.4674 16.1718C41.4758 16.1605 41.4842 16.1492 41.4954 16.138C41.5178 16.1126 41.5403 16.0873 41.5655 16.0619C41.5739 16.0535 41.5823 16.045 41.5935 16.0338C41.6103 16.0197 41.6271 16.0056 41.644 15.9915C41.658 15.9802 41.6748 15.9662 41.6916 15.9549C41.7112 15.9408 41.7308 15.9295 41.7504 15.9155C41.7701 15.9014 41.7897 15.8873 41.8121 15.876L52.1811 9.82079L52.1867 7.94226L41.8177 13.9975L41.8149 13.9919Z",
    fill: "url(#paint13_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9135 15.1635L66.9107 17.042L65.9326 16.4759L65.9382 14.5974L66.9135 15.1635Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4595 8.93079L66.9135 15.6704L65.9382 15.1043L77.4814 8.36188L78.4595 8.93079Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4595 8.93079L78.4539 9.88554L66.9106 16.628L66.9134 15.6704L78.4595 8.93079Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9811 16.6139L43.9755 18.4925L43.0002 17.9264L43.0059 16.0479L43.9811 16.6139Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8784 10.9135L81.8728 11.8711L70.3296 18.6135L70.3352 17.656L81.8784 10.9135Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3352 17.1491L70.3296 19.0276L69.3516 18.4615L69.3572 16.5801L70.3352 17.1491Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2973 12.8991L85.2917 13.8539L73.7485 20.5963L73.7541 19.6387L85.2973 12.8991Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7542 19.1318L73.7486 21.0103L72.7705 20.4442L72.7761 18.5657L73.7542 19.1318Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9845 21.1652L74.9789 23.0437L52.1812 9.81512L52.184 7.93658L74.9845 21.1652Z",
    fill: "#66696F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5216 10.3784L55.5188 11.336L43.9756 18.0784L43.9812 17.1209L55.5216 10.3784Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5215 10.3784L43.9811 17.1209L43.0059 16.5548L54.5463 9.81232L55.5215 10.3784Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8784 10.9136L70.3352 17.656L69.3572 17.0899L80.9004 10.3475L81.8784 10.9136Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 18.5967L47.3944 20.4752L46.4192 19.9091L46.4248 18.0306L47.4 18.5967Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9433 12.364L47.4 19.1036L46.4248 18.5375L57.968 11.7979L58.9433 12.364Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9433 12.364L58.9377 13.3215L47.3945 20.0612L47.4001 19.1036L58.9433 12.364Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3622 14.3496L50.8218 21.0892L49.8438 20.5231L61.387 13.7806L62.3622 14.3496Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3624 14.3495L62.3568 15.3043L50.8164 22.0467L50.822 21.0892L62.3624 14.3495Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8218 20.5822L50.8162 22.4607L49.8381 21.8946L49.8437 20.0161L50.8218 20.5822Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.241 22.5649L54.2354 24.4463L53.2573 23.8774L53.2629 21.9988L54.241 22.5649Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7842 16.3323L54.241 23.0747L53.2629 22.5058L64.8061 15.7662L65.7842 16.3323Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7842 16.3323L65.7786 17.2898L54.2354 24.0295L54.241 23.0747L65.7842 16.3323Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6598 24.5505L57.6542 26.4291L56.679 25.863L56.6846 23.9844L57.6598 24.5505Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2031 18.3178L69.1975 19.2726L57.6543 26.015L57.6599 25.0574L69.2031 18.3178Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.203 18.3178L57.6598 25.0574L56.6846 24.4913L68.225 17.7489L69.203 18.3178Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0788 26.5333L61.0731 28.4146L60.0979 27.8457L60.1035 25.9672L61.0788 26.5333Z",
    fill: "#333132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6221 20.3006L72.6164 21.2582L61.0732 27.9978L61.0788 27.043L72.6221 20.3006Z",
    fill: "#383B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.622 20.3006L61.0788 27.043L60.1035 26.4741L71.6439 19.7345L72.622 20.3006Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0377 6.94525L63.4945 13.6877L62.5193 13.1216L74.0625 6.37915L75.0377 6.94525Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2974 12.8991L73.7542 19.6387L72.7761 19.0726L84.3193 12.3302L85.2974 12.8991Z",
    fill: "#7A7C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6121 12.4147L67.174 0.55767C65.8961 -0.183042 63.8195 -0.183042 62.55 0.55767L40.677 13.3328C39.4075 14.0735 39.4132 15.2818 40.6911 16.0253L61.1292 27.8851C62.4071 28.6258 64.4809 28.6258 65.7532 27.8851L87.6261 15.11C88.8956 14.3693 88.89 13.161 87.6121 12.4175V12.4147ZM64.6154 27.2205C63.968 27.5979 62.9115 27.5979 62.2614 27.2205L41.8232 15.3606C41.1703 14.9832 41.1703 14.3693 41.8148 13.9919L52.1838 7.93662L74.9816 21.1652L64.6126 27.2205H64.6154ZM86.4883 14.4453L76.1166 20.5034L53.3188 7.27477L63.6906 1.21671C64.338 0.839309 65.3917 0.839309 66.0446 1.21671L86.4827 13.0765C87.1329 13.4539 87.1357 14.0679 86.4912 14.4453H86.4883Z",
    fill: "#898B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5734 13.7975C88.5734 13.8595 88.565 13.9242 88.551 13.9862C88.5397 14.0482 88.5201 14.1101 88.4977 14.1721C88.4753 14.2341 88.4445 14.2988 88.4108 14.358C88.3744 14.4256 88.3296 14.4903 88.2791 14.5551C88.2203 14.6312 88.153 14.7044 88.0773 14.7748C87.9596 14.8846 87.8223 14.986 87.6654 15.0818C87.6514 15.0902 87.6402 15.0987 87.6262 15.1043L65.7532 27.8795C65.5346 28.0062 65.2964 28.1104 65.0386 28.1949C64.8396 28.2597 64.6322 28.3104 64.4192 28.3498C64.2819 28.3752 64.1418 28.3949 64.0017 28.409C63.8812 28.4202 63.7607 28.4287 63.6374 28.4343C63.5253 28.4371 63.4132 28.4399 63.3011 28.4343C63.1918 28.4343 63.0853 28.4259 62.9788 28.4174C62.8723 28.409 62.7658 28.3977 62.6593 28.3808C62.55 28.3639 62.4407 28.347 62.3342 28.3245C62.2193 28.2991 62.1044 28.2738 61.9923 28.24C61.855 28.2005 61.7233 28.1555 61.5972 28.1048C61.4319 28.04 61.2749 27.964 61.1292 27.8795L40.6911 16.0196C40.0465 15.6451 39.727 15.155 39.727 14.665L39.7214 16.5435C39.7214 17.0335 40.0409 17.5264 40.6855 17.8982L61.1236 29.758C61.2693 29.8425 61.4262 29.9185 61.5916 29.9833C61.7205 30.034 61.8522 30.0791 61.9867 30.1185C62.0988 30.1495 62.2109 30.1776 62.3286 30.203C62.4351 30.2255 62.5444 30.2452 62.6537 30.2593C62.7602 30.2734 62.8639 30.2875 62.9732 30.2959C63.0797 30.3044 63.189 30.31 63.2955 30.3128C63.4076 30.3128 63.5197 30.3128 63.6318 30.3128C63.7523 30.31 63.8756 30.3016 63.9961 30.2875C64.1362 30.2734 64.2763 30.2537 64.4136 30.2283C64.6266 30.1889 64.834 30.1382 65.033 30.0734C65.288 29.9889 65.529 29.8847 65.7476 29.758L87.6205 16.9829C87.6205 16.9829 87.6458 16.966 87.6598 16.9603C87.8167 16.8646 87.9568 16.7604 88.0717 16.6533C88.1474 16.5829 88.2147 16.5097 88.2735 16.4337C88.324 16.3689 88.3688 16.3041 88.4052 16.2365C88.4389 16.1745 88.4697 16.1126 88.4921 16.0506C88.5145 15.9887 88.5313 15.9267 88.5453 15.8647C88.5566 15.8028 88.565 15.738 88.5678 15.676C88.5678 15.6676 88.5678 15.6563 88.5678 15.6479L88.5734 13.7693C88.5734 13.7693 88.5734 13.7891 88.5734 13.7975Z",
    fill: "url(#paint14_linear_871_183171)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1928 25.4321V26.1615L31.8411 28.1076V27.3754L35.1928 25.4321Z",
    fill: "#11141E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8411 28.1076L29.7393 26.8797V26.1502L31.8411 27.3753V28.1076Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9 34.022V34.7515L46.5483 36.6948V35.9653L49.9 34.022Z",
    fill: "#11141E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5482 36.6948L44.4492 35.4697V34.7374L46.5482 35.9654V36.6948Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8828 86.7787L37.7655 75.8229L18.8828 64.8643L0 75.8229L18.8828 86.7787Z",
    fill: "#E8D6A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6005 82.3006L30.0503 80.301L11.1676 69.3424L7.71777 71.3449L26.6005 82.3006Z",
    fill: "#B58850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6535 97.7344L18.7708 108.693V86.7786L37.6535 75.8229V97.7344Z",
    fill: "#B58850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9383 102.212L26.4885 104.215V101.156L29.9383 99.1539V102.212Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9383 83.3596L26.4885 85.3592V82.3006L29.9383 80.301V83.3596Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8828 108.693L0 97.7344V75.8229L18.8828 86.7786V108.693Z",
    fill: "#D6B477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57349 94.0759V98.416L8.31473 100.587V96.2474L4.57349 94.0759ZM8.14098 100.283L4.74724 98.3146V94.3773L8.14098 96.3459V100.283Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55162 97.9119L6.03084 98.1907V96.36L6.30267 96.5178L5.78983 95.3856L5.27979 95.9235L5.55162 96.0812V97.9119Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85753 98.6723L7.33955 98.9511V97.1176L7.61138 97.2754L7.09854 96.146L6.58569 96.6811L6.85753 96.8388V98.6723Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80757 99.4355L5.08081 97.8527V98.2104L7.80757 99.7932V99.4355Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93408 96.605V100.945L12.6753 103.117V98.7765L8.93408 96.605ZM12.5016 102.812L9.10783 100.844V96.9064L12.5016 98.8751V102.812Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6743 100.235V101.097L10.2791 100.866C10.2119 100.827 10.1558 100.858 10.1558 100.937V101.044L11.4505 101.796V101.689C11.4505 101.61 11.3945 101.514 11.3272 101.475L10.9321 101.244V100.382C11.3553 100.554 11.6803 100.323 11.6803 99.8101V98.9117L11.1899 98.6272L11.0134 98.9793L11.4225 99.2158L10.6855 99.7876L10.9265 99.1933L10.5454 98.9736L10.7976 98.3991L9.92603 97.895V98.7934C9.92603 99.3032 10.2511 99.9143 10.6743 100.23V100.235Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3115 99.1454V103.486L17.0528 105.657V101.317L13.3115 99.1454ZM16.879 105.353L13.4853 103.384V99.4468L16.879 101.415V105.353Z",
    fill: "#815300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6483 102.162C14.7857 102.167 14.9398 102.17 15.1079 102.246C15.1023 102.255 15.0995 102.266 15.0995 102.28V103.508C15.0995 103.626 15.0183 103.674 14.9146 103.615C14.8137 103.556 14.7296 103.412 14.7296 103.294C14.7296 103.241 14.6932 103.176 14.6455 103.15C14.6007 103.125 14.5615 103.145 14.5615 103.198C14.5615 103.421 14.7184 103.694 14.9118 103.807C15.1051 103.919 15.2621 103.826 15.2621 103.604V102.376C15.2621 102.376 15.2621 102.348 15.2537 102.334C15.419 102.452 15.5759 102.629 15.7133 102.781C15.8702 102.787 15.9963 102.759 16.1925 102.872C16.299 102.934 16.4559 103.094 16.554 103.176C16.4923 102.505 15.9431 101.635 15.2621 101.199V100.9C15.2621 100.847 15.2256 100.782 15.178 100.756C15.1304 100.731 15.0939 100.751 15.0939 100.804V101.1C14.4129 100.748 13.8637 100.982 13.802 101.579C13.9001 101.607 14.057 101.632 14.1635 101.694C14.3597 101.807 14.483 101.982 14.6427 102.159L14.6483 102.162Z",
    fill: "#815300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_871_183171",
    x1: 80.934,
    y1: 53.9564,
    x2: 47.9971,
    y2: 53.9564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#313334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#37393A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#464748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4C4D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_871_183171",
    x1: 81.999,
    y1: 51.0133,
    x2: 49.2611,
    y2: 51.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4A4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4A4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#4A4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4C4D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#555658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#656668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7A7B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#969799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8B8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6E7072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#66686A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_871_183171",
    x1: 57.2339,
    y1: 48.5659,
    x2: 73.9672,
    y2: 48.5659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4B4C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#555658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696A6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_871_183171",
    x1: 65.4309,
    y1: 29.8651,
    x2: 73.6525,
    y2: 40.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#737476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#828385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#808183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#727375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7B7C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8B8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A0A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BCBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B1B2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#949698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#8C8E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#78797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_871_183171",
    x1: 73.3197,
    y1: 44.2878,
    x2: 73.3197,
    y2: 35.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4D5155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#53565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#65676A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7E80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_871_183171",
    x1: 56.2249,
    y1: 46.1072,
    x2: 74.8193,
    y2: 46.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#565758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5D5E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#707173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#727375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7B7C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8B8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A0A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BCBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B1B2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#949698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8C8E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#87898B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#717477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#606367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#54585C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4D5155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_871_183171",
    x1: 77.8736,
    y1: 42.6092,
    x2: 66.4729,
    y2: 27.9653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#595B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#626465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6C6D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6E6F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#78797B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7F81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_871_183171",
    x1: 74.5388,
    y1: 47.5323,
    x2: 56.4267,
    y2: 47.5323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#57595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#595B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#626465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6C6D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6E6F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#78797B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7F81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_871_183171",
    x1: 71.4982,
    y1: 32.8786,
    x2: 63.3569,
    y2: 47.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43464D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#43464D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#43464D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#464950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#52555C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#727479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#85878A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8C8E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_871_183171",
    x1: 27.0152,
    y1: 39.4633,
    x2: 55.8353,
    y2: 86.2878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4C5057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5F6268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#696C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#75777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#898A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ACABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9B9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_871_183171",
    x1: 20.9733,
    y1: 112.329,
    x2: 41.6117,
    y2: 76.9371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#696C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#75777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#898A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A5A4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5D5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#403F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_871_183171",
    x1: 7.4348,
    y1: 104.085,
    x2: 28.0733,
    y2: 68.6936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#696C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#75777C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#898A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A5A4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#A6A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5D5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#403F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_871_183171",
    x1: 53.3133,
    y1: 8.28865,
    x2: 87.2592,
    y2: 8.28865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7C7C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#616366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#515457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4C4F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#45474B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#37383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_871_183171",
    x1: 41.3273,
    y1: 12.2429,
    x2: 52.1839,
    y2: 12.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_871_183171",
    x1: 39.4524,
    y1: 22.0439,
    x2: 88.4024,
    y2: 22.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#66696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#717378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#909093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ACABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#858586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5B5D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#414447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#383B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#333539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#252628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_183171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsDaily);
export default __webpack_public_path__ + "static/media/stats_daily.e892dc6af359249f688b61808b5839dc.svg";
export { ForwardRef as ReactComponent };